const testIds = {
  productionTag: 'production-tag',
  devTag: 'dev-tag',
};

export default testIds;
